export const STICKER_SIZE = 80;
export const STICKER_MARGIN = 10;
